document.addEventListener('click', function (e) {
    let target = checkEventTarget(e, '._js-news-more');
    if (!target) {
        return;
    }
    e.preventDefault();

    let newsContainer = target.closest('._js-news-container');
    let nextPage = target.dataset.next;
    let newsBlock = target.closest('._js-news-block');
    if (newsBlock) {
        let paramName = newsBlock.dataset.paginationName;

        let params = [];
        params = getParametersExcluding(window.location.href, paramName)

        newsContainer?.classList.add('disabled');

        getNewsList(params, nextPage)
            .then(res => {
                if (res.data.html) {
                    updateNewsDOM(res.data.html, newsBlock);
                    updateURLParams(paramName, 'page-' + nextPage);
                }
            })
            .catch(error => console.error('Ошибка загрузки новостей:', error))
            .finally(() => {
                newsContainer?.classList.remove('disabled');
            });
    }
});

document.addEventListener('click', function (e) {
    let target = checkEventTarget(e, '._js-tag-btn');
    if (!target) {
        return;
    }
    e.preventDefault();

    let newsContainer = target.closest('._js-news-container');
    let tagId = target.dataset.id;
    let paramName = target.dataset.name;
    let tagsListBlock = target.closest('._js-list-filter-btns');
    let tagsReset = tagsListBlock?.querySelector('._js-reset-tag-btn');
    let newsBlock = document.querySelector('._js-news-block');
    if (newsBlock) {
        let paginationName = newsBlock.dataset.paginationName;
        updateURLParams(paginationName, "");

        let params = [];
        params = getParametersExcluding(window.location.href, paramName);
        if (!target.classList.contains('_active')) {
            removeActiveClassFromFilter(tagsListBlock, '._js-tag-btn');
            tagsReset?.classList.remove('_active')
            if (tagId) {
                params[paramName] = tagId;
            } else {
                resetFilterParam(tagsReset, newsBlock, paramName);
                return;
            }
            target.classList.add('_active');
        } else {
            removeActiveClassFromFilter(tagsListBlock, '._js-tag-btn');
            resetFilterParam(tagsReset, newsBlock, paramName);
            return;
        }

        newsContainer?.classList.add('disabled');

        getNewsList(params)
            .then(res => {
                if (res.data.html) {
                    updateNewsDOM(res.data.html, newsBlock, true);
                    updateURLParams(paramName, tagId ?? "");
                }
            })
            .catch(error => console.error('Ошибка загрузки новостей:', error))
            .finally(() => {
                newsContainer?.classList.remove('disabled');
            });
    }

});

document.addEventListener('click', function (e) {
    let target = checkEventTarget(e, '._js-reset-tag-btn');
    if (!target) {
        return;
    }
    e.preventDefault();

    let newsBlock = document.querySelector('._js-news-block');
    let paramName = target.dataset.name;
    let tagsListBlock = target.closest('._js-list-filter-btns');

    removeActiveClassFromFilter(tagsListBlock, '._js-tag-btn');
    resetFilterParam(target, newsBlock, paramName)
});

function updateNewsDOM(resHTML, blockDOM, wholeBlock = false) {
    let answerDOM = getDocumentObjectFromHtmlString(resHTML, false);
    if (answerDOM) {
        if (wholeBlock) {
            blockDOM.innerHTML = answerDOM.innerHTML;
        } else {
            let elementsListInDOM = blockDOM.querySelector('._js-news-list');
            let elementsListInAnswer = answerDOM.querySelector('._js-news-list');
            let paginationInDOM = blockDOM.querySelector('._js-news-more');
            let paginationInAnswer = answerDOM.querySelector('._js-news-more');

            if (elementsListInAnswer) {
                elementsListInDOM.innerHTML += elementsListInAnswer.innerHTML;
            }
            if (paginationInDOM && paginationInAnswer) {
                paginationInDOM.parentNode.replaceChild(paginationInAnswer, paginationInDOM);
            } else {
                paginationInDOM.parentNode.removeChild(paginationInDOM);
            }
        }
    }
}

function removeActiveClassFromFilter(block, childSelector) {
    let childrens = block.querySelectorAll(childSelector);
    if (childrens.length) {
        childrens.forEach(item => {
            item.classList.remove('_active');
        })
    }
}

function resetFilterParam(targetBtn, contentBlock, paramToRemove) {
    let newsContainer = targetBtn.closest('._js-news-container');
    targetBtn?.classList.add('_active');
    let paginationName = contentBlock.dataset.paginationName;
    if (paginationName) {
        updateURLParams(paginationName, "");
    }
    let params = [];
    params = getParametersExcluding(window.location.href, paramToRemove);
    newsContainer?.classList.add('disabled');

    getNewsList(params)
        .then(res => {
            if (res.data.html) {
                updateNewsDOM(res.data.html, contentBlock, true);
                updateURLParams(paramToRemove, "")
            }
        })
        .catch(error => console.error('Ошибка загрузки новостей:', error))
        .finally(() => {
            newsContainer?.classList.remove('disabled');
        });
}